import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";

import userReducer from "./reducer_user";
import appConfigReducer from "./reducer_app_config";
import employeeReducer from "./reducer_employee";
import claimOptionsReducer from "./reducer_claim_options";
import dashboardReducer from "./reducer_dashboard";
import brokerReducer from "./reducer_broker";
import analyticsReducer from "./reducer_analytics";
import elogReducer from "./reducer_elog";
import clinicReducer from "./reducer_clinic";
import errorReducer from "./reducer_error";

const appReducer = combineReducers({
  user: userReducer,
  appConfig: appConfigReducer,
  employee: employeeReducer,
  claimOptions: claimOptionsReducer,
  dashboard: dashboardReducer,
  broker: brokerReducer,
  analytics: analyticsReducer,
  eLOG: elogReducer,
  clinics: clinicReducer,
  error: errorReducer
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    Object.keys(state).forEach(key => {
      storage.removeItem(`persist:${key}`);
    });
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
